// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileSettingsForm-containerWith-umltS {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.MobileSettingsForm-container-RdnJM {
    max-width: 100%;
}

/* Text - Start */

.MobileSettingsForm-subText-xOn8v {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.MobileSettingsForm-navigationLink-nRRCu a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.MobileSettingsForm-navigationLink-nRRCu a:hover,
.MobileSettingsForm-navigationLink-nRRCu a:focus,
.MobileSettingsForm-navigationLink-nRRCu a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.MobileSettingsForm-noPadding-cXdpM {
    padding: 0;
}

.MobileSettingsForm-heading-URuV2 {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.MobileSettingsForm-widthInner-uETP6 {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.MobileSettingsForm-noMargin-ShULy {
    margin: 0;
}

.MobileSettingsForm-formControlInputTable-r3ux6 {
    border: none;
    width: 100px;
    height: auto;
}

.MobileSettingsForm-backBtn-umcIL {
    margin-left: 15px;
    display: inline-block;
}

.MobileSettingsForm-backBtn-umcIL:active,
.MobileSettingsForm-backBtn-umcIL:hover,
.MobileSettingsForm-backBtn-umcIL:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.MobileSettingsForm-textAlignRight-BMIpj {
    text-align: right;
}

.MobileSettingsForm-displayInlineBlock-_osQr {
    display: inline-block;
}

.MobileSettingsForm-displayBlock-Y5wQe {
    display: block;
}

.MobileSettingsForm-countryCode-SEdh7 {
    width: 15%;
    vertical-align: top;
}

.MobileSettingsForm-vtrMiddle-pFFuX {
    vertical-align: middle;
}

/* commonCss */

.MobileSettingsForm-editIcon-ZOP0X {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.MobileSettingsForm-iconBtn-eL5Ly,
.MobileSettingsForm-iconBtn-eL5Ly:hover,
.MobileSettingsForm-iconBtn-eL5Ly:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.MobileSettingsForm-profileImg-olNJc {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.MobileSettingsForm-profileImgSection-QxYnD {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.MobileSettingsForm-profileImgWidth-i7LBm {
    margin: 0;
    max-width: 100% !important;
}

.MobileSettingsForm-searchInput-xSqP1 {
    width: 100%;
    max-width: 320px;
}

.MobileSettingsForm-backgroundImg-U_7qt {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.MobileSettingsForm-exportDisplay-GWelD {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.MobileSettingsForm-exportTextSection-hEj84 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.MobileSettingsForm-exportText-uwl6U {
    display: inline-block;
    padding-right: 5px;
}

.MobileSettingsForm-exportTextContainer-wurgw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.MobileSettingsForm-vtrTextBottom-x3AXQ {
    vertical-align: text-bottom;
}

.MobileSettingsForm-exportImg-UZQ_l {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.MobileSettingsForm-noLink-zbHFU,
.MobileSettingsForm-noLink-zbHFU:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.MobileSettingsForm-singleCard-bjK8P {
    width: 500px;
    margin: 0 auto;
}

.MobileSettingsForm-defaultIcon-eVXaq {
    background-size: 50px;
}

.MobileSettingsForm-assignProviderSearchInput-p9cg_ {
    width: 100%;
    max-width: 324px;
}

.MobileSettingsForm-searchGroupContainer-B0VZc {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .MobileSettingsForm-searchGroupContainer-B0VZc {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .MobileSettingsForm-widthInner-uETP6 {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .MobileSettingsForm-aboutGrid-J6qpZ img {
    position: relative;
    top: -25px !important;
  }

  .MobileSettingsForm-responsiveView-ibnAQ {
    width: 100% !important;
    max-width: 175px !important;
  }

  .MobileSettingsForm-positionFive-EZhio {
    top: 28% !important;
  }

  .MobileSettingsForm-positionTwo-cStfK {
    top: 28% !important;
  }

  .MobileSettingsForm-responsiveContentOne-apEll {
    top: -50px !important;
  }

  .MobileSettingsForm-positionFour-f3pj0 {
    top: -50px !important;
  }

  .MobileSettingsForm-totalCss-KZbRC {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .MobileSettingsForm-navbar-expand-lg-opA2b .MobileSettingsForm-navbar-toggler-N7YoM {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .MobileSettingsForm-profileImgSection-QxYnD {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .MobileSettingsForm-navigationLink-nRRCu a {
    color: var(--primary-foreground) !important;
  }

  .MobileSettingsForm-widthInner-uETP6 {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .MobileSettingsForm-responsiveContentOne-apEll {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .MobileSettingsForm-positionTwo-cStfK {
    top: 24% !important;
    left: -5% !important;
  }

  .MobileSettingsForm-positionThree-GfLj9 {
    top: 70% !important;
    left: -5% !important;
  }

  .MobileSettingsForm-positionFour-f3pj0 {
    top: -42px !important;
    right: -5% !important;
  }

  .MobileSettingsForm-positionFive-EZhio {
    top: 20% !important;
    right: -5% !important;
  }

  .MobileSettingsForm-positionSix-Otl8Z {
    top: 70% !important;
    right: -5% !important;
  }

  .MobileSettingsForm-responsiveView-ibnAQ {
    width: 100% !important;
    max-width: 115px !important;
  }

  .MobileSettingsForm-aboutGrid-J6qpZ img {
    top: -1px !important;
  }

  .MobileSettingsForm-contentOne-DZ2kc h1 {
    font-size: 16px !important;
  }

  .MobileSettingsForm-contentOne-DZ2kc p {
    font-size: 12px !important;
  }


  .MobileSettingsForm-totalCss-KZbRC {
    width: 100% !important;
  }

  .MobileSettingsForm-padding-ixPkt {
    padding: 0px 0 0 60px !important;
  }

  .MobileSettingsForm-singleCard-bjK8P {
    width: 100% !important;
  }

  .MobileSettingsForm-navigationLink-nRRCu a:hover,
  .MobileSettingsForm-navigationLink-nRRCu a:focus,
  .MobileSettingsForm-navigationLink-nRRCu a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .MobileSettingsForm-navbar-collapse-G224_.MobileSettingsForm-show-jlmxg {
    right: 0% !important;
    top: 0 !important;
  }

  .MobileSettingsForm-navbar-collapse-G224_ {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .MobileSettingsForm-content-Ox33v {
    float: none;
  }

  .MobileSettingsForm-mr-auto-cszRa.MobileSettingsForm-navbar-nav-kZh9Q {
    padding-bottom: 80px !important;
  }

  .MobileSettingsForm-navigationLink-nRRCu a {
    color: var(--primary-foreground) !important;
  }

  .MobileSettingsForm-footer-zXMmx {
    padding: 35px 0 0 15px;
  }

  .MobileSettingsForm-widthInner-uETP6 {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .MobileSettingsForm-responsiveNoPadding-VxriX {
    padding: 0px !important;
  }

  .MobileSettingsForm-contentOne-DZ2kc {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .MobileSettingsForm-aboutContainer-_0ovt {
    padding: 30px 0 30px !important;
  }

  .MobileSettingsForm-noPosition-j0yoM {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .MobileSettingsForm-mobimleImg-fCuHI {
    display: none !important;
  }

  .MobileSettingsForm-totalCss-KZbRC {
    width: 100% !important;
  }

  .MobileSettingsForm-imgWidth-svJ4y {
    padding: 18px !important;
  }

  .MobileSettingsForm-searchInput-xSqP1,
  .MobileSettingsForm-assignProviderSearchInput-p9cg_ {
    max-width: 100% !important;
  }

  .MobileSettingsForm-exportText-uwl6U {
    display: inline-block;
  }

  .MobileSettingsForm-gridSystem-MBSfg {
    grid-template-columns: auto !important;
  }

  .MobileSettingsForm-padding-ixPkt {
    padding: 52px 0 0 0 !important;
  }

  .MobileSettingsForm-heading-URuV2 {
    padding: 30px 0 24px !important;
  }

  .MobileSettingsForm-singleCard-bjK8P {
    width: 100% !important;
  }

  .MobileSettingsForm-displayGrid-AyJrP {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .MobileSettingsForm-boxInner-ITYTn {
    padding: 35px 0 !important;
  }

  .MobileSettingsForm-navigationLink-nRRCu a:hover,
  .MobileSettingsForm-navigationLink-nRRCu a:focus,
  .MobileSettingsForm-navigationLink-nRRCu a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .MobileSettingsForm-whiteDropdown-g3GG_ select {
    width: 120px !important;
  }
}

.MobileSettingsForm-container-RdnJM {
  margin: 0 auto;
}

.MobileSettingsForm-paddingTop-X1XMw {
  padding-top: 20px;
}

.MobileSettingsForm-deleteIcon-Nd5hL {
  width: 80px;
}

.MobileSettingsForm-audioSection-jupjK {
  border: 1px solid var(--primary-bg);
  border-radius: 45px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 50px;
  padding: 7px 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  gap: 8px;
}

.MobileSettingsForm-fontSize-L8_Zr {
  position: relative;
  top: 1px;
  font-size: 14px;
  margin-left: 3px;
}

.MobileSettingsForm-flex-AzaKM {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 18px;
  cursor: pointer;
}

.MobileSettingsForm-flexBox-MnfH4 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  margin-bottom: 15px;
}

.MobileSettingsForm-flexBox-MnfH4:nth-child(1) {
  margin-bottom: 0;
}

.MobileSettingsForm-audioImgContainer-N_TYw {
  width: 24px;
  height: 24px;
  position: relative;
}

.MobileSettingsForm-audioImgContainer-N_TYw img {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  -o-object-fit: contain;
     object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/SiteAdmin/MobileSettingsForm/MobileSettingsForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACzPA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,sBAAmB;KAAnB,mBAAmB;AACrB","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/Common.css';\n@import '../../../components/responsive-common.css';\n\n.container {\n  margin: 0 auto;\n}\n\n.paddingTop {\n  padding-top: 20px;\n}\n\n.deleteIcon {\n  width: 80px;\n}\n\n.audioSection {\n  border: 1px solid var(--primary-bg);\n  border-radius: 45px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 50px;\n  padding: 7px 20px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  gap: 8px;\n}\n\n.fontSize {\n  position: relative;\n  top: 1px;\n  font-size: 14px;\n  margin-left: 3px;\n}\n\n.flex {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  cursor: pointer;\n}\n\n.flexBox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 15px;\n}\n\n.flexBox:nth-child(1) {\n  margin-bottom: 0;\n}\n\n.audioImgContainer {\n  width: 24px;\n  height: 24px;\n  position: relative;\n}\n\n.audioImgContainer img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  inset: 0;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `MobileSettingsForm-containerWith-umltS`,
	"container": `MobileSettingsForm-container-RdnJM`,
	"subText": `MobileSettingsForm-subText-xOn8v`,
	"navigationLink": `MobileSettingsForm-navigationLink-nRRCu`,
	"noPadding": `MobileSettingsForm-noPadding-cXdpM`,
	"heading": `MobileSettingsForm-heading-URuV2`,
	"widthInner": `MobileSettingsForm-widthInner-uETP6`,
	"noMargin": `MobileSettingsForm-noMargin-ShULy`,
	"formControlInputTable": `MobileSettingsForm-formControlInputTable-r3ux6`,
	"backBtn": `MobileSettingsForm-backBtn-umcIL`,
	"textAlignRight": `MobileSettingsForm-textAlignRight-BMIpj`,
	"displayInlineBlock": `MobileSettingsForm-displayInlineBlock-_osQr`,
	"displayBlock": `MobileSettingsForm-displayBlock-Y5wQe`,
	"countryCode": `MobileSettingsForm-countryCode-SEdh7`,
	"vtrMiddle": `MobileSettingsForm-vtrMiddle-pFFuX`,
	"editIcon": `MobileSettingsForm-editIcon-ZOP0X`,
	"iconBtn": `MobileSettingsForm-iconBtn-eL5Ly`,
	"profileImg": `MobileSettingsForm-profileImg-olNJc`,
	"profileImgSection": `MobileSettingsForm-profileImgSection-QxYnD`,
	"profileImgWidth": `MobileSettingsForm-profileImgWidth-i7LBm`,
	"searchInput": `MobileSettingsForm-searchInput-xSqP1`,
	"backgroundImg": `MobileSettingsForm-backgroundImg-U_7qt`,
	"exportDisplay": `MobileSettingsForm-exportDisplay-GWelD`,
	"exportTextSection": `MobileSettingsForm-exportTextSection-hEj84`,
	"exportText": `MobileSettingsForm-exportText-uwl6U`,
	"exportTextContainer": `MobileSettingsForm-exportTextContainer-wurgw`,
	"vtrTextBottom": `MobileSettingsForm-vtrTextBottom-x3AXQ`,
	"exportImg": `MobileSettingsForm-exportImg-UZQ_l`,
	"noLink": `MobileSettingsForm-noLink-zbHFU`,
	"singleCard": `MobileSettingsForm-singleCard-bjK8P`,
	"defaultIcon": `MobileSettingsForm-defaultIcon-eVXaq`,
	"assignProviderSearchInput": `MobileSettingsForm-assignProviderSearchInput-p9cg_`,
	"searchGroupContainer": `MobileSettingsForm-searchGroupContainer-B0VZc`,
	"aboutGrid": `MobileSettingsForm-aboutGrid-J6qpZ`,
	"responsiveView": `MobileSettingsForm-responsiveView-ibnAQ`,
	"positionFive": `MobileSettingsForm-positionFive-EZhio`,
	"positionTwo": `MobileSettingsForm-positionTwo-cStfK`,
	"responsiveContentOne": `MobileSettingsForm-responsiveContentOne-apEll`,
	"positionFour": `MobileSettingsForm-positionFour-f3pj0`,
	"totalCss": `MobileSettingsForm-totalCss-KZbRC`,
	"navbar-expand-lg": `MobileSettingsForm-navbar-expand-lg-opA2b`,
	"navbar-toggler": `MobileSettingsForm-navbar-toggler-N7YoM`,
	"positionThree": `MobileSettingsForm-positionThree-GfLj9`,
	"positionSix": `MobileSettingsForm-positionSix-Otl8Z`,
	"contentOne": `MobileSettingsForm-contentOne-DZ2kc`,
	"padding": `MobileSettingsForm-padding-ixPkt`,
	"navbar-collapse": `MobileSettingsForm-navbar-collapse-G224_`,
	"show": `MobileSettingsForm-show-jlmxg`,
	"content": `MobileSettingsForm-content-Ox33v`,
	"mr-auto": `MobileSettingsForm-mr-auto-cszRa`,
	"navbar-nav": `MobileSettingsForm-navbar-nav-kZh9Q`,
	"footer": `MobileSettingsForm-footer-zXMmx`,
	"responsiveNoPadding": `MobileSettingsForm-responsiveNoPadding-VxriX`,
	"aboutContainer": `MobileSettingsForm-aboutContainer-_0ovt`,
	"noPosition": `MobileSettingsForm-noPosition-j0yoM`,
	"mobimleImg": `MobileSettingsForm-mobimleImg-fCuHI`,
	"imgWidth": `MobileSettingsForm-imgWidth-svJ4y`,
	"gridSystem": `MobileSettingsForm-gridSystem-MBSfg`,
	"displayGrid": `MobileSettingsForm-displayGrid-AyJrP`,
	"boxInner": `MobileSettingsForm-boxInner-ITYTn`,
	"whiteDropdown": `MobileSettingsForm-whiteDropdown-g3GG_`,
	"paddingTop": `MobileSettingsForm-paddingTop-X1XMw`,
	"deleteIcon": `MobileSettingsForm-deleteIcon-Nd5hL`,
	"audioSection": `MobileSettingsForm-audioSection-jupjK`,
	"fontSize": `MobileSettingsForm-fontSize-L8_Zr`,
	"flex": `MobileSettingsForm-flex-AzaKM`,
	"flexBox": `MobileSettingsForm-flexBox-MnfH4`,
	"audioImgContainer": `MobileSettingsForm-audioImgContainer-N_TYw`
};
module.exports = ___CSS_LOADER_EXPORT___;
